/* eslint-disable react/no-unescaped-entities */
// import { div, div } from '@tarojs/components';
import classNames from 'classnames';
import styles from './index.module.less';

function ServiceAgreementEN() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.serviceAgreement}>
        <div className={styles.title}>Last Updated ：10.30.2023</div>
        <div className={styles.title}>Introduction</div>
        <div>
          Welcome to use our products and services! The Service Agreement
          (referred to as "Service Agreement") is an agreement between you and
          Carbonstop (Beijing) Technology Co., Ltd. (referred to as "Carbonstop"
          or “us”) regarding the registration of a Carbonstop account and the
          use of various products and services (referred to as "the Service")
          provided by us. In order to provide you a pleasant experience, please
          be sure to carefully read and fully understand the terms of the
          Service Agreement,{' '}
          <span className={classNames(styles.bold, styles.underline)}>
            and the terms of exemption or limitation of liability will be
            highlighted in bold or underlined for your extra attention. If you
            have any questions about the Service Agreement, please contact with
            us at your convenience.
          </span>
        </div>
        <div className={styles.title}>Definitions</div>
        <div>
          1. <span className={styles.bold}>Carbonstop:</span> refers to
          Carbonstop (Beijing) Technology Co., Ltd., which develops and provides
          the products and services, as well as any relevant affiliates
          established now or in the future, either individually or collectively.
        </div>
        <div>
          2.{' '}
          <span className={styles.bold}>Carbonstop Service/The Service:</span>{' '}
          refers to <span className={styles.bold}>Carbon AI</span> which is
          developed and serviced by us. Regardless of the nature of the
          "products/services", this "Service Agreement" will still apply.
        </div>
        <div>
          3. <span className={styles.bold}>Carbonstop Website:</span> The
          internet addresses where we provide Services to Users are the official
          website (www.carbonstop.net) and the Ccloud SaaS
          (ccloud.carbonstop.net).
        </div>
        <div>
          4. <span className={styles.bold}>User (referred to as "you"):</span>{' '}
          Individual users, refer to natural persons who register and use the
          Service in their personal capacity, excluding certain authorized users
          defined below. Customers, refer to legal entities or other
          organizations with management authority that register for the Service
          account through authorized natural persons and have the ability to
          invite individuals to join their organizations as authorized users.
          Authorized users refer to natural persons who have been authorized or
          invited by Customers to join and use the Service.{' '}
        </div>
        <div className={styles.title}>Special Notice</div>
        <div>
          1、
          <span className={styles.bold}>
            If you check "I have read and agreed to the Service Agreement"
            during the registration process or use the Service in any other way,
            it is assumed that you have read, understood, and voluntarily
            accepted all the terms of the Service Agreement. If you disagree
            with any part of the Service Agreement, please do not register, stop
            using the Service, and immediately cease the registration process.
          </span>{' '}
          If you have any doubt about the content of the Service Agreement
          (especially the terms related to exempting or limiting liability),
          feel free to contact us through the contact information provided in
          the Service Agreement, and we will provide further explanation and
          clarification as needed.{' '}
        </div>
        <div>
          2、Please note that this Service Agreement may change{' '}
          <span className={styles.bold}>
            based on business functions, usage rules, laws, regulations,
            regulatory requirements, the need for better service provision, and
            business strategies, among other factors.
          </span>{' '}
          For significant changes made by us to the content of this Service
          Agreement, we will provide prominent notification (including
          notification through the Carbonstop website).{' '}
          <span className={styles.bold}>
            The revised agreement and rules will take effect immediately upon
            the publication of such notification. We will also archive the old
            versions of the Service Agreement for your reference. If you
            continue to use our service after the publication of the revised
            Service Agreement, it assumed that you have thoroughly read,
            understood, and accepted the revised Service Agreement, and you are
            willing to be bound by the revised terms of the Service Agreement.
          </span>{' '}
        </div>
        <div>
          3、
          <span className={styles.bold}>
            In order to provide you with the functionality of the Service, we
            may collect, use, and share your information in compliance with
            relevant laws and regulations. We will only process your information
            based on Customers’ requests, and we will not be liable for the
            actions of such Customer. Please refer to our "Privacy Policy" for
            the details of your personal information and related processing.
          </span>
        </div>
        <div>
          4、
          <span className={styles.bold}>
            After registering for the Service account, you can use some of the
            functions provided by the Service. When you subscribe to or purchase
            products or services or accept invitations from other customer
            organizations, you will gain access to all the functions of the
            Service.
          </span>
        </div>
        <div>
          5、
          <span className={styles.bold}>
            Ownership, operational rights, and related interests of the Service
            and its derivative services belong to us.
          </span>
        </div>

        <div className={styles.title}>Service Agreement Details</div>
        <div className={styles.title}>Account Registration and Usage Guide</div>
        <div>
          1、The Service is primarily provided for adults. Minors are not
          permitted to create accounts without the consent of their parents or
          legal guardians.{' '}
          <span className={styles.bold}>
            If you are under 18 years of age, it is crucial that you rediv the
            Service Agreement with your parents or other legal guardians and
            obtain their consent prior to any registration or use of the
            Service.
          </span>
        </div>
        <div>
          2、
          <span className={styles.bold}>
            If you are a user from a country or region outside mainland China,
            you are required to comply with the laws of your country or region,
            as well as this Service Agreement, when entering into or performing
            this Service Agreement and using the Service.
          </span>
        </div>
        <div>
          3、You can obtain a service account and become a service user by
          following the instructions on the registration interface provided by
          the Service, filling in the required information, reading and agreeing
          to the Service Agreement, and completing the entire registration
          process.
        </div>
        <div>
          4、If the{' '}
          <span className={styles.bold}>same mobile phone number</span> is
          associated with multiple service accounts, or if multiple service
          accounts are found to be controlled by the same individual identified
          through CarbonStop's investigation, these accounts will be considered
          as the same user.
        </div>
        <div>
          5、You should register your account with authentic identity
          information, and the account name, profile picture, and introduction
          provided by you should not contain any illegal or harmful information.
          If such aforementioned information is detected, we reserve the right
          to reject the registration.{' '}
          <span className={styles.bold}>
            Additionally, if it's discovered after registration that you have
            used false information to register your account or that your
            account's profile picture, introduction, or other registration
            information contains any illegal or harmful information or infringes
            on the legal rights of others, we may take measures such as
            requesting corrections within a specified time, suspending use,
            canceling registration, or reclaiming the account.
          </span>
        </div>
        <div>
          6、
          <span className={styles.bold}>
            You have the right to use your phone number or email to log into the
            Service, obtain an account, and independently set a password that
            meets security requirements.
          </span>{' '}
          Your account shall be solely kept by you, and we will never ask you to
          provide your account password at any time. Therefore, please ensure
          properly safeguard your account and make sure to log out and exit the
          Service correctly after each use.{' '}
          <span className={styles.bold}>
            We shall not be liable for any losses or consequences that may arise
            from your voluntary disclosure of your account or from attack or
            fraud by others. In such events, you should seek judicial or
            administrative remedies against the infringing parties.
          </span>
        </div>
        <div>
          7、
          <span className={styles.bold}>
            Since your service account is associated with your personal
            information and business information, please ensure that your
            account is used solely by you to guarantee its security and
            confidentiality. You are responsible for all actions and outcomes
            associated with your account (including but not limited to entering
            business information, business data, purchasing products/services,
            and disclosing information, etc.), unless we are at fault.
          </span>
        </div>
        <div>
          8、
          <span className={styles.bold}>
            If you detect any unauthorized use of your account to log into
            Ccloud SaaS or any other situation that could result in the theft or
            loss of your account, it is recommended that you immediately notify
            our customer service team. Please understand that we require a
            reasonable amount of time to take actions upon your requests and
            that such actions taken by us may not be able to prevent the
            occurrence or aggravation of the damage. Unless we are at fault, we
            shall not be liable for the aforementioned damage.
          </span>
        </div>
        <div>
          9、As user accounts are associated with users' personal and business
          information, you can transfer your account when the conditions of the
          account transfer process are met. Once your account is transferred,
          the rights and obligations associated with the account will be
          transferred as well.{' '}
          <span className={styles.bold}>
            Under all other circumstances, your account shall not be transferred
            in any manner. Or else, we shall be entitled to hold you liable for
            breach and all consequences that may be thus caused shall be solely
            borne by you.
          </span>
        </div>
        <div>
          10、If you lose account information due to personal reasons, and need
          to recover it, please provide the required information as per our
          account recovery requirements, and ensure that the information you
          provide is legal, genuine, and valid. If the aforementioned
          information does not meet our requirements and fails the security
          verification, we have the right to refuse to provide account recovery
          services. If the unique credentials for the account are no longer
          valid, we have the right to refuse to support the account recovery.
          For example, if a phone number has been resold, we may refuse to
          support the recovery of the account linked to the original phone
          number.
        </div>
        <div>
          11、When you wish to terminate the use of the Service, you can submit
          an account cancellation request to our customer service team. If you
          are an authorized user, you can submit a team exit request to your
          company or organization and cancel your account. This request will be
          processed by the customer administrator. Prior to cancelling your
          account, we will verify your personal identity, security status,
          device information, and other information. Please understand and
          acknowledge that the act of canceling an account is irreversible.{' '}
          <span className={styles.bold}>
            Once the account is canceled, we will cease providing services to
            you and, as per your request, either delete your personal
            information or anonymize it, unless laws and regulations require
            otherwise.
          </span>
        </div>
        <div>
          12、If you engage in activities that violate the laws and regulations
          during the registration and use of the Service,{' '}
          <span className={styles.bold}>
            we reserve the right to freeze or cancel your account, delete, or
            anonymize your stored data and information. We are not obligated to
            compensate for any losses or consequences incurred as a result of
            the use of the Service, unless we are at fault.
          </span>
        </div>
        <div className={styles.title}>Service Content and Usage Guidelines</div>
        <div>
          1、The specific service period you are entitled to will start from the
          actual date of purchase.
        </div>
        <div>
          2、You can use the Service for carbon-related business calculations
          and data management. You must ensure the safety, stability, and
          validity of the models, data, attachments, products, and services you
          upload when using the Service. Your uploads must not contain viruses,
          worms, trojans, or other harmful computer code, files, scripts, or
          programs that could potentially harm our systems and data. If
          vulnerabilities arise due to your content, including but not limited
          to viruses, trojans, worms, or other harmful programs, or if security
          vulnerabilities occur due to your non-compliance with this Service
          Agreement, you will be solely responsible and liable for any resulting
          losses or risks. If such vulnerabilities cause us any loss or risk, we
          have the right to claim compensation from you.
        </div>
        <div>
          3、If you are an enterprise administrator, you have the ability to
          enable or disable access permissions for authorized users to use the
          Service. The choices and decisions made by enterprise users may result
          in the access, use, disclosure, modification, restriction, or deletion
          of some or all user content. If you are using the Service on behalf of
          a Customer, you confirm that the Customer has fully explain this
          situation to its authorized users in advance and has obtained their
          explicit consent.
        </div>
        <div className={styles.title}>
          Privacy, Account, and Password Protection
        </div>
        <div>
          1、We place a high priority on the protection of users' personal
          information and privacy. Our "Privacy Policy" forms an integral part
          of the Service Agreement. We collect, store, use, and disclose privacy
          and personal information within the Service according to the policies
          published in the "Privacy Policy." Users should carefully read the
          "Privacy Policy" before using the Service.
        </div>
        <div>
          2、Both parties shall keep strictly confidential the content of the
          Service Agreement, as well as any other confidential information
          learned by either party during the signing and performance of the
          Service Agreement unless it has been publicly disclosed through open
          channels. Confidential information includes, but is not limited to,
          data stored by users on Carbonstop servers, development service
          content, results, related documents, materials, etc. Confidential
          information may not be disclosed to any third party without the prior
          written consent of the other party, except as required by applicable
          laws, courts, or government authorities.
        </div>
        <div>
          3、Users should take measures to keep their login passwords
          confidential. We will never request login passwords from users in any
          form. Users should not disclose login passwords to any third party,
          otherwise, the user may be liable for any losses suffered by us or
          other users or visitors of the Service.
        </div>
        <div>
          4、This confidentiality provision shall survive the termination of the
          Service Agreement. If either party breaches any confidentiality
          obligations, it shall indemnify the other Party against any losses
          caused thereby.
        </div>
        <div className={styles.title}>Intellectual Property Rights</div>
        <div>
          1、Unless otherwise stated, the content contained in the Service is
          our property. This includes but is not limited to span, images, data,
          information, software, graphics, photos, opinions, suggestions, web
          pages, etc. We may change the content of the service at any time
          without notice. Although we attempt to provide accurate information,
          we do not assume any obligation or responsibility for the accuracy and
          completeness of the information provided. For your convenience, the
          service may contain links to third-party websites, but the inclusion
          of links does not imply any endorsement of such websites or products
          or services they offered therein, nor does it guarantee the validity
          of the information provided on these sites.
        </div>
        <div>
          2、We fully own all intellectual property rights (including but not
          limited to trademark rights, copyrights, patents, trade secrets, etc.)
          of Carbon AI and the Service, and you only obtain limited use rights
          based on the Service Agreement. The relevant rights to Carbon AI and
          the Service, including but not limited to the name, logo, and business
          identifiers, belong to us. Without our authorization, you are not
          permitted to use or authorize third parties to use these rights. You
          agree to indicate the source of the content as "Carbonstop " when
          using the content of the Service with our authorization.
        </div>
        <div>
          3、We shall be responsible for the settlement of any third-party
          claims or intellectual property infringement related to Carbon AI due
          to our reasons. However, you shall bear all responsibility for the
          following situations and any liabilities arising from them:
        </div>
        <div>
          <div className={styles.circle} />
          When we have already provided the latest version of Carbon AI, which
          could prevent the mentioned accusations or claims, you still use an
          older version;
        </div>
        <div>
          <div className={styles.circle} />
          You use Carbon AI together with other software, programs, or data,
          resulting in the mentioned accusations or claims;
        </div>
        <div>
          <div className={styles.circle} />
          You make any modifications, adaptations, reverse compilation, reverse
          engineering, or any other form of handling of Carbon AI without our
          prior consent, resulting in accusations or claims of infringement.
        </div>
        <div className={styles.title}>Termination of the Service Agreement</div>
        <div>
          1、In addition to the other provisions of the Service Agreement, the
          Service Agreement may also be terminated under the following
          circumstances:
        </div>
        <div>
          <div className={styles.circle} />
          The Service Agreement may be terminated in advance by mutual agreed by
          both parties.
        </div>
        <div>
          <div className={styles.circle} />
          In the event of a breach of contract by one party, and the breach is
          not corrected, and the consequences of the breach are not eliminated
          within 5 days after the other party's notification, the other party
          has the right to terminate the Service Agreement.
        </div>
        <div>
          <div className={styles.circle} />
          If one party becomes the subject of bankruptcy proceedings or other
          insolvency, receivership, liquidation, or any other similar
          proceedings, the other party has the right to terminate the Service
          Agreement.
        </div>
        <div>
          <div className={styles.circle} />
          If a force majeure event affects one or both parties' ability to
          perform the obligations under the Service Agreement and lasts for more
          than 30 days, either party has the right to terminate the Service
          Agreement.
        </div>
        <div>
          <div className={styles.circle} />
          We revoke or cancel a user account. In this case, the Service
          Agreement terminates on the date of the account revocation or
          cancellation.
        </div>
        <div>
          <div className={styles.circle} />
          Users may cancel their accounts when they meet the criteria for
          account cancellation. In this case, the Service Agreement terminates
          on the date of the account cancellation.
        </div>
        <div>
          <div className={styles.circle} />
          We have the right to terminate the Service by providing reasonable
          advance notice based on our own business arrangements. In this case,
          the Service Agreement terminates on the date on which the Service is
          officially discontinued through legal procedures and methods.
        </div>
        <div>
          2、After the Service Agreement is terminated, we will no longer be
          able to provide any services to users or perform any other
          obligations, including but not limited to retaining or disclosing any
          information in the user's account.
        </div>
        <div>
          3、Termination of the Service Agreement does not affect the validity
          of the intellectual property rights clause and other clauses that
          should continue to be effective according to their content. It also
          does not affect the relevant rights and obligations of the parties
          before the termination of the Service Agreement, including but not
          limited to the right of the non-breaching party to take actions
          against the breaching party for corresponding liability for breach of
          contract in accordance with the Service Agreement.
        </div>
        <div className={styles.title}>Service Disclaimer</div>
        <div>
          We do not make any statement or warranty regarding the following
          matters:
        </div>
        <div>
          <div className={styles.circle} />
          We strive to provide users with normal and stable Carbon AI services.
          However, we cannot guarantee compatibility or errors-free operation of
          the Carbon AI services with specific software or hardware (such as
          systems, phones, computers) used by users.
        </div>
        <div>
          <div className={styles.circle} />
          Given that Carbon AI services are standardized software services, we
          cannot guarantee that we will be able to make special modifications to
          meet users' personalized requirements.
        </div>
        <div>
          <div className={styles.circle} />
          Carbon AI generates results based on standardized calculation models.
          We cannot guarantee that the results or reports will be absolutely
          accurate or not misleading. We will not assume any liability or
          obligation for any usage of these results or reports by the users in
          any way, including but not limited to any responsibility or obligation
          arising from reasonable errors, omissions, or other issues with these
          results or reports.
        </div>
        <div>
          <div className={styles.circle} />
          To the fullest extent permitted by applicable laws and regulations, we
          shall not be liable for any indirect, incidental, special, punitive,
          or other damages. This includes, but not limited to, damages caused by
          personal injury or property damage, damages caused by loss of profits,
          loss of data, business interruption, computer failure or malfunction,
          loss of business information, arising from or in connection with the
          use of or inability to use the Service.
        </div>
        <div className={styles.title}>Use of Third-Party Content</div>
        <div>
          1、The Service may contain or provide users with third-party content,
          such as data authorized by databases like ecoinvent. We cannot make
          any representations or warranties regarding any such third-party
          content. We will not assume any liability for any kind or nature of
          losses, damages, costs, or expenses resulting from by any third-party
          content.
        </div>
        <div className={styles.title}>Notices</div>
        <div>1、Effective contact information</div>
        <div>
          When registering or accepting our services, you are required to
          provide us with authentic and valid contact information (including
          your E-mail address, telephone number, and mailing address). In case
          of any change of your contact information, you shall update relevant
          information in time and keep your contact information effective.
        </div>
        <div>
          Any account used by you to log in to the Ccloud SaaS or to receive
          instant messages, such as website messages and system messages, may
          also be deemed as your valid contact information.
        </div>
        <div>
          We may send various notices to one or more of your contact information
          mentioned above, and it is your responsibility to promptly pay close
          attention to the content of such notices, as they may have significant
          beneficial or adverse effects on your rights or obligations.
        </div>
        <div>2、Delivery of notices</div>
        <div>
          We will send notices to you through the above-mentioned contact
          information. A written notice sent by electronic means, including but
          not limited to an announcement published on the Ccloud SaaS, a short
          message sent to your mobile phone by the telephone number provided by
          you, an E-mail sent to the E-mail address provided by you, or a system
          message or website message sent to your account, will be considered
          duly delivered upon successful transmission.; Any written notice in
          written, if sent to the mailing address provided by you, shall be
          deemed as being duly delivered to you on the fifth calendar day
          following its dispatch.
        </div>
        <div>
          You shall ensure that the contact information provided by you is
          accurate, effective, and up to date. If any legal document fails to be
          delivered or is not delivered in time due to your inaccurate contact
          information or your failure to notify us of the change of your contact
          information promptly, any legal consequences that may be thus caused
          shall be borne by you solely.
        </div>
        <div>You can contact us through the followings:</div>
        <div>Email：mail@carbonstop.net</div>
        <div>Tel：+86（010）50973498</div>
        <div className={styles.title}>Liability for Breach of Contract</div>
        <div>1、Identification of breach</div>
        <div>
          You will be considered in breach of this Service Agreement if you:
        </div>
        <div>
          Use our Products and Services in violation of applicable laws or
          regulations; or
        </div>
        <div>
          Violate the provisions of this Service Agreement, associated
          agreements, or any other agreements entered into with us.
        </div>
        <div>2、Dealing with breach</div>
        <div>
          If any information you release on the Ccloud SaaS constitutes a breach
          of contract, we will delete or shield such information immediately
          according to relevant platform rules.
        </div>
        <div>
          If any action you take on the Ccloud SaaS or any action not taken on
          the Ccloud SaaS but which has any effect on us or our users , is in
          breach of contract, we may suspend providing part of or all the
          Products and Services to you. If your act constitutes a fundamental
          breach of contract, we may close your account and terminate providing
          the Products and Services to you.
        </div>
        <div>
          If you commit fraud, fake products, embezzlement of any other person's
          account, and other specific circumstances upon your breach of contract
          or there is any risk that you are endangering the security of others’
          accounts, we will take compulsory measures, such as closing or
          cancellation of your account, according to the risk level of your
          behavior.
        </div>
        <div>
          We may publicize on the Ccloud SaaS the measures taken against your
          aforementioned breaches and other illegal acts that have been
          confirmed in the valid legal documents by state administrative or
          judicial organs.
        </div>
        <div>3、Liability for compensation</div>
        <div>
          If your act causes any loss to us, you are responsible for providing
          compensation in accordance with the provisions of this Service
          Agreement. The losses (if any) for which you shall be liable include
          but are not limited to:
        </div>
        <div>
          Reasonable attorney's fee and legal cost paid by us, and necessary
          expenses paid by us for eliminating the effect;
        </div>
        <div>
          The fines, penalties, liquidated damages, and compensation that we may
          have to pay due to administrative penalty, judicial adjudication, or
          mediation within the legal scope; and
        </div>
        <div>
          Loss of goodwill and loss of reasonably anticipated profits (such as
          decrease of operating revenue, etc.), which can be calculated
          according to relevant estimation standards, These may be based on an
          independent and reasonable analysis by third party, our own reasonable
          analysis based on big data, and other reasonable methods for
          calculating profits and losses; and
        </div>
        <div>Other losses that we may incur as a result of your actions.</div>
        <div>
          If any third party claims are lodged against us due to your actions,
          we may claim compensation from you after we have performed relevant
          obligations, such as payment obligation, to the third party.
        </div>
        <div>
          If any losses are incurred by you due to a breach of contract caused
          by our intention or gross negligence, we shall bear the liability for
          compensation to you on the basis of your actual direct losses.
        </div>
        <div className={styles.title}>Dispute Resolution and Others</div>
        <div>
          1、The Service Agreement is governed by the laws of the People's
          Republic of China (excluding the Hong Kong Special Administrative
          Region, Macau Special Administrative Region, and Taiwan) for the
          purposes of the Service Agreement.
        </div>
        <div>
          2、Any dispute arising from the performance of the Service Agreement
          shall be resolved through friendly negotiation between the parties. If
          negotiation fails, either party may bring a lawsuit in the People's
          Court with competent jurisdiction in our registered location.
        </div>
      </div>
    </div>
  );
}

export default ServiceAgreementEN;
